module.exports = __webpack_public_path__ + "static/media/img-background1.dd4f5428.jpg";